export default __webpack_public_path__ + "048e0ba330c2468fcf65b64bb06475d4.svg";